import React, { useContext, useEffect } from 'react'

import Form from '../../../elem/form/Form'
import FormResultsSummary from '../../../elem/form/FormResultsSummary'
import { DataContext } from './DataContext'
import getFilterParamsFromForm from '../../../../utils/form/getFilterParamsFromForm'
import clearFormFields from '../../../../utils/form/clearFormFields'

const Filter = ({ filterExpanded, syncFilterState, width }) => {
    const dataContext = useContext(DataContext)
    const {
        filterFields,
        fetchFilterFields,
        fetchResultsCount,
        filterResultsCount,
        filterResultsLoading,
        params,
        setParams,
        formName
    } = dataContext

    const onSubmit = (data, e) => {
        const newParams = {
            PageSize: 50,
            Page: 1,
            SortByField: params['sample'].SortByField,
            SortOrder: params['sample'].SortOrder,
            ...getFilterParamsFromForm(data),
        }
        setParams(newParams, 'sample')
        syncFilterState(false)
    }

    const onReset = (getValues, setValue) => {
        clearFormFields(getValues, setValue)
        const newParams = {
            PageSize: 50,
            Page: 1,
            SortByField: params['sample'].SortByField,
            SortOrder: params['sample'].SortOrder,
        }
        setParams(newParams, 'sample')
    }

    useEffect(() => {
        fetchFilterFields()
    }, [])

    return (
        <>
            <FormResultsSummary 
                filterResultsCount={filterResultsCount}
                filterResultsLoading={filterResultsLoading}
                filterExpanded={filterExpanded}
            />
            <div
                className={`explorerFilter ${
                    filterExpanded ? 'is-visible' : 'is-hidden'
                }`}
            >
                <div className="content">
                    <Form
                        formWidth={width}
                        formName={formName}
                        formFields={filterFields}
                        filterResultsCount={filterResultsCount}
                        filterResultsLoading={filterResultsLoading}
                        onSubmit={onSubmit}
                        onReset={onReset}
                        onChange={fetchResultsCount}
                    />
                </div>
            </div>
        </>
    )
}

export default Filter
